import React from 'react'
import Text from '@component/Text/Text'
import IconCheck from '@svg/common/ic_check.svg'
import IconSelectArrow from '@svg/common/ic_select_arrow.svg'

interface Props {
    title: string
    isSelected: boolean

    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void

    renderLeft?: JSX.Element | JSX.Element[]
    showLeftTick?: boolean
    showRightChevron?: boolean
    disabled?: boolean
    className?: string
    dataCy?: string
}

const FilterButton = ({
    title,
    isSelected,
    onClick,
    showLeftTick = false,
    showRightChevron = false,
    disabled = false,
    renderLeft,
    className,
    dataCy,
}: Props) => {
    const getContainerStyle = () => {
        const roundedStyle = `rounded-[3px]`
        const paddingStyle = `px-[15px] py-[8px]`
        const spaceStyle = 'space-x-[7px]'

        return `flex justify-center items-center ${spaceStyle} ${paddingStyle} border border-gray06 dark:border-dark_gray06 hover:border-gray01 dark:hover:border-dark_gray01 cursor-pointer bg-white dark:bg-bg_dark_white01 ${roundedStyle}  ${
            isSelected &&
            'border-primary dark:border-dark_primary bg-primary_tint02 dark:bg-dark_primary_tint02 dark:bg-dark_primary_tint02'
        } ${disabled && 'bg-gray09 dark:bg-dark_gray09'}`
    }

    const getTextStyle = () => {
        const fontStyle = 'text-body2'
        const colorStyle = `${
            disabled === false ? 'text-gray01 dark:text-dark_gray01' : 'text-gray04 dark:text-dark_gray04'
        }`
        return `${fontStyle} ${colorStyle}`
    }

    return (
        <div
            onClick={e => {
                if (disabled) {
                    if (e?.cancelable) {
                        e.preventDefault()
                    }
                    e.stopPropagation()
                    return
                }
                onClick && onClick(e)
            }}
            data-cy={dataCy}
            className={`${getContainerStyle()} ${className}`}>
            {showLeftTick && (
                <IconCheck
                    className={`${
                        isSelected ? 'fill-primary dark:fill-dark_primary' : 'fill-gray02 dark:fill-dark_gray02'
                    } w-[16px]`}
                />
            )}
            {renderLeft}
            <Text
                className={`grow ${getTextStyle()} ${
                    isSelected ? 'text-gray01 dark:text-dark_gray01' : 'text-gray01 dark:text-dark_gray01'
                }`}>
                {title}
            </Text>
            {showRightChevron && <IconSelectArrow className={'w-[16px] ml-4 fill-gray01 dark:fill-dark_gray01'} />}
        </div>
    )
}

export default FilterButton
